import { sanitizeRuntimeConfig } from './core/sanitizeRuntimeConfig.js';

const CONFIG_PATHS = ['/app/config.json', 'app/config.json', '/config.json', './config.json'];

const shouldLogBootstrap = () => {
  if (import.meta.env?.DEV) return true;
  try {
    if (typeof window !== 'undefined') {
      if (window.__ENABLE_BOOTSTRAP_LOGS__ === true || window.__ENABLE_RUNTIME_CONFIG_LOGS__ === true) {
        return true;
      }
      const hash = window.location?.hash || '';
      if (hash.includes('bootstrapLogs') || hash.includes('runtimeConfigLogs')) {
        return true;
      }
    }
    if (typeof localStorage !== 'undefined') {
      const flag = localStorage.getItem('bootstrapLogs') || localStorage.getItem('runtimeConfigLogs');
      if (flag === 'true') return true;
    }
  } catch (_) {}
  return false;
};

const BOOTSTRAP_LOGS_ENABLED = shouldLogBootstrap();
const debugLog = (...args) => {
  if (!BOOTSTRAP_LOGS_ENABLED) return;
  try {
    console.info('[bootstrap]', ...args);
  } catch (_) {}
};

async function preloadRuntimeConfig() {
  if (typeof window === 'undefined' || window.__RUNTIME_CONFIG__) return;

  for (const path of CONFIG_PATHS) {
    try {
      debugLog('attempting runtime config fetch from', path);
      const res = await fetch(path, { cache: 'no-store' });
      if (res && res.ok) {
        window.__RUNTIME_CONFIG__ = sanitizeRuntimeConfig(await res.json());
        debugLog('runtime config loaded from', path, window.__RUNTIME_CONFIG__);
        return;
      } else {
        debugLog('runtime config fetch returned non-200 for', path, res?.status);
      }
    } catch (err) {
      debugLog('runtime config fetch failed for', path, err?.message || err);
      // try next path
    }
  }
}

(async () => {
  try {
    await preloadRuntimeConfig();
  } catch (err) {
    console.warn('[bootstrap] runtime config failed to load', err?.message || err);
  }

  try {
    if (window.__RUNTIME_CONFIG__?.serviceProfile === 'aws_standard') {
      const { default: TenantAccessScreen } = await import('./components/TenantAccessScreen.js');
      const screen = new TenantAccessScreen({ start: () => import('./main.js') });
      await screen.open();
      return;
    }
    await import('./main.js');
  } catch (err) {
    console.error('[bootstrap] failed to start application', err);
  }
})();
